import ArrowFowardIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {useTranslation} from 'react-i18next';
import {ModalAction} from './modal';
import {translations} from '../../i18n/translations';

export type ModalBtnsOpts = {
  left?: {
    type: 'cancel' | 'back';
    disabled?: boolean;
    loading?: boolean;
    onClick?: () => void;
  };

  right?: {
    type: 'next' | 'save' | 'delete' | 'confirm' | 'add';
    disabled?: boolean;
    loading?: boolean;
    onClick?: () => void;
  };
};

export function useModalBtns(opts?: ModalBtnsOpts): ModalAction[] {
  const {t} = useTranslation();

  // ---------------------- LEFT BUTTON ----------------------
  const leftBtn = (() => {
    if (opts?.left?.type === undefined) return undefined;

    if (opts.left.type === 'cancel') {
      const cancel: ModalAction = {
        label: t(translations.modal.cancel),
        type: 'destructive',
        disabled: opts.left.disabled,
        loading: opts.left.loading,
        onClick: opts.left.onClick,
      };

      return cancel;
    }

    if (opts.left.type === 'back') {
      const back: ModalAction = {
        label: t(translations.modal.back),
        type: 'destructive',
        startIcon: <ArrowBackIosNewIcon sx={{fontSize: '14px !important'}} />,
        disabled: opts.left.disabled,
        loading: opts.left.loading,
        onClick: opts.left.onClick,
      };

      return back;
    }
  })();

  // ---------------------- RIGHT BUTTON ----------------------
  const rightBtn = (() => {
    if (!opts?.right) return undefined;

    if (opts.right.type === 'next') {
      const next: ModalAction = {
        label: t(translations.modal.next),
        endIcon: <ArrowFowardIcon sx={{fontSize: '14px !important'}} />,
        type: 'nondestructive',
        buttonType: 'button',
        disabled: opts.right.disabled,
        loading: opts.right.loading,
        onClick: opts.right.onClick,
      };

      return next;
    }

    if (opts.right.type === 'save') {
      const save: ModalAction = {
        label: t(translations.modal.save),
        type: 'nondestructive',
        buttonType: 'button',
        disabled: opts.right.disabled,
        loading: opts.right.loading,
        onClick: opts.right.onClick,
      };

      return save;
    }

    if (opts.right.type === 'confirm') {
      const confirm: ModalAction = {
        label: t(translations.modal.confirm),
        type: 'nondestructive',
        buttonType: 'button',
        disabled: opts.right.disabled,
        loading: opts.right.loading,
        onClick: opts.right.onClick,
      };

      return confirm;
    }

    if (opts.right.type === 'delete') {
      const del: ModalAction = {
        label: t(translations.modal.delete),
        type: 'nondestructive',
        buttonType: 'button',
        disabled: opts.right.disabled,
        loading: opts.right.loading,
        onClick: opts.right.onClick,
      };

      return del;
    }

    if (opts.right.type === 'add') {
      const add: ModalAction = {
        label: t(translations.modal.add),
        type: 'nondestructive',
        buttonType: 'button',
        disabled: opts.right.disabled,
        loading: opts.right.loading,
        onClick: opts.right.onClick,
      };

      return add;
    }
  })();

  // ---------------------- RETURN ----------------------
  // Two buttons layout
  if (leftBtn && rightBtn) return [leftBtn, rightBtn];

  // One button layout
  if (leftBtn || rightBtn) return [leftBtn ?? rightBtn!];

  // No buttons layout
  return [];
}
